/**
 * Reports Hooks
 */

import { useApi } from '../../../shared/hooks/useApi';
import { reportsService } from '../services/reportsService';

export function useGeneratedReports(museum?: string) {
  return useApi(() => reportsService.getGeneratedReports(museum), [museum]);
}

export function useRecentActivities(limit: number = 10) {
  return useApi(() => reportsService.getRecentActivities(limit), [limit]);
}
